<template>
  <div>
    <main-component />
  </div>
</template>

<script>
import MainComponent from '@/components/Login/index'

export default {
  components: {
    MainComponent
  }
}
</script>
